const components = [
  "Term",
]

export default components